import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  font-weight: 600;\n  color: ", ";\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  width: 100%;\n  max-width: ", "px;\n  margin: 0 auto;\n  padding: 0 60px;\n  box-sizing: border-box;\n\n  @media screen and (max-width: ", "px) {\n    padding: 0 30px;\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n          opacity: ", ";\n        "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n          visibility: hidden;\n        "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  margin-left: 16px;\n\n  ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    height: ", "px;\n\n    &:before {\n      content: '';\n      position: fixed;\n      left: 0;\n      z-index: 0;\n      height: inherit;\n      right: 0;\n      background-color: rgba(245, 245, 245, ", ");\n      border-top: 1px solid rgba(240, 240, 240, ", ");\n      box-shadow: 0 3px 15px 0 rgba(0, 0, 0, ", ");\n    }\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  height: 104px;\n  position: fixed;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  top: 80px;\n  z-index: 1;\n  left: 0;\n  right: 0;\n\n  @media screen and (max-width: ", "px) {\n    top: 70px;\n  }\n\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  height: 64px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import { AcornsIcon } from '@acorns/icons';
import styled, { css } from '../utils/styling/styled-components';
import { ACTION_STRIP_SUBTEXT, ACTION_STRIP_TITLE, BACK_BUTTON } from '../utils/testing/TestIDs';
import { ActionButton } from '../ActionButton';
import { Heading2, Title } from '../Typography';
import { useStickyScroll } from './hooks';
var Wrapper = styled.div(_templateObject());
var Container = styled.div(_templateObject2(), function (props) {
  return props.theme.breakpoints.md;
}, function (props) {
  return css(_templateObject3(), 104 - (104 - 64) * props.scrollPercent, props.scrollPercent, props.scrollPercent, props.scrollPercent * 0.05);
});
var Content = styled.div(_templateObject4());
var TitleArea = styled.div(_templateObject5(), function (props) {
  switch (props.visibilityMode) {
    case 'none':
      return css(_templateObject6());

    case 'onscroll':
      return css(_templateObject7(), props.scrollPercent);

    default:
      return '';
  }
});
var InnerContainer = styled.div(_templateObject8(), function (props) {
  return props.maxWidth + 120;
}, function (props) {
  return props.theme.breakpoints.md;
});
var Subtext = styled(Heading2)(_templateObject9(), function (props) {
  return props.theme.colors.stone;
});
export var DesktopStrip = function DesktopStrip(_ref) {
  var title = _ref.title,
      subtext = _ref.subtext,
      action = _ref.action,
      onBack = _ref.onBack,
      _ref$backIcon = _ref.backIcon,
      backIcon = _ref$backIcon === void 0 ? AcornsIcon.Icon.UtilityArrowLeft : _ref$backIcon,
      titleVisibility = _ref.titleVisibility,
      _ref$maxWidth = _ref.maxWidth,
      maxWidth = _ref$maxWidth === void 0 ? 800 : _ref$maxWidth,
      className = _ref.className,
      _ref$titleTestId = _ref.titleTestId,
      titleTestId = _ref$titleTestId === void 0 ? ACTION_STRIP_TITLE : _ref$titleTestId,
      _ref$subtextTestId = _ref.subtextTestId,
      subtextTestId = _ref$subtextTestId === void 0 ? ACTION_STRIP_SUBTEXT : _ref$subtextTestId,
      _ref$showBackButton = _ref.showBackButton,
      showBackButton = _ref$showBackButton === void 0 ? true : _ref$showBackButton;

  var _useStickyScroll = useStickyScroll({
    scrollDistance: 64
  }),
      scrollPercent = _useStickyScroll.scrollPercent;

  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(Container, {
    scrollPercent: scrollPercent,
    className: className
  }, /*#__PURE__*/React.createElement(InnerContainer, {
    maxWidth: maxWidth
  }, /*#__PURE__*/React.createElement(Content, null, showBackButton && /*#__PURE__*/React.createElement(ActionButton, {
    testId: BACK_BUTTON,
    icon: /*#__PURE__*/React.createElement(AcornsIcon, {
      icon: backIcon,
      width: "24px",
      height: "24px"
    }),
    actionText: "Go back",
    onPress: onBack
  }), /*#__PURE__*/React.createElement(TitleArea, {
    scrollPercent: scrollPercent,
    visibilityMode: titleVisibility
  }, title && /*#__PURE__*/React.createElement(Title, {
    "data-testid": titleTestId,
    bold: true
  }, title), subtext && /*#__PURE__*/React.createElement(Subtext, {
    "data-testid": subtextTestId
  }, subtext))), action && action)));
};